import React from 'react'
import classNames from 'classnames'
import styles from '../../../CSS/main.css'
import {Col} from '../List/Col'
import {User} from "../List/Item/CommentsItem";

type Props = {
  pendingCount: number
  user: User
}
const WelcomeMessage: React.VFC<Props> = ({pendingCount, user}) => {
  return (
    <div className={classNames([styles.Table, styles.TopLinks])}>
      <Col>
        Welcome Back, {user.displayName}. There are <b>{pendingCount} pending comments</b> for review.
      </Col>
    </div>
  )
}

export default WelcomeMessage
